/*
 * File: ListTagsCard.tsx
 * Project: a-a
 * File Created: Friday, 31st October 2025 10:36:23 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Thursday, 13th November 2025 8:19:31 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import React, { useEffect, useState } from 'react';
import zeplinColor from '../../../../../theme/Color';
import { Box, Chip, Typography } from '@mui/material';
import CustomPopOver from '../../../../shared/CustomPopOver/CustomPopOver';
import CustomTextField from '../../../../shared/CustomTextField/CustomTextField';
import { useInput } from '../../../../../customHook/useInput';
import { ZoomInfoService } from '../../../../../service/zoominfo.service';
import { useLocation } from 'react-router-dom';
import CustomAlert from '../../../../shared/CustomAlert/CustomAlert';
import CustomAlertContain from '../../../../shared/CustomAlert/CustomAlertContain';
import styles from './ListTagCard.module.css';

const ListTagsCard = ({ isTargeted, data }: { isTargeted: boolean; data: any }) => {
  const location = useLocation();
  const [alert, setAlert] = useState('');
  const [type, setType] = useState('Tag');
  const [loading, setLoading] = useState(false);
  const [targeted, setTargeted] = useState(false);
  const {
    handleChange: handleTagChange,
    handleBlur: handleTagBlur,
    clearInput: clearTag,
    value: tag,
    // setValue: setTag,
  } = useInput('', () => true);
  const [anchorEl, setAnchorEl] = React.useState<HTMLDivElement | null>(null);
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const handleClick = (e: any) => {
    setAnchorEl(e.currentTarget);
  };

  const handleDelete = async (id: string) => {
    // console.info('You clicked the delete icon.');

    try {
      setLoading(true);
      const res = await ZoomInfoService.deleteTarget(id);
      console.log(res);
      setTargeted(false);
      setAlert('Removed target successfully');
      // getTag();
    } catch (err) {
      setAlert('Something went wrong.');
    } finally {
      setLoading(false);
      // clearTag();
      // setAnchorEl(null);
    }
  };

  const addTarget = async (id: string) => {
    try {
      const res = await ZoomInfoService.addTarget({ companyId: `${id}` });
      console.log(res);
      setAlert('Added to target successfully');
      setTargeted(true);
      // getUpdates(false);
    } catch (err) {
      setAlert('Something went wrong.');
    }
  };
  // useEffect(() => {
  //   getTag();
  // }, []);
  return (
    <Box
      sx={{
        padding: '16px',
        display: 'flex',
        gap: '16px',
        border: `1px solid ${zeplinColor.Neutral5}`,
        borderRadius: '14px',
        flexDirection: 'column',
      }}
    >
      <Box sx={{ display: 'flex', gap: '16px' }}>
        <Box sx={{ display: 'flex', gap: '8px', width: '58px', alignItems: 'center' }}>
          <img
            src={'/assets/zoominfo-tags.svg'}
            width={'20px'}
            height={'20px'}
            alt='zoominfo-lists'
          />
          <Typography variant='responsiveBody3' color={zeplinColor.Neutral8}>
            Lists
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
          {isTargeted || targeted ? (
            <Chip
              icon={<img src={'/assets/zoominfo-check.svg'} width='18px' height='18px' />}
              label='Target account'
              // onClick={handleClick}
              onDelete={() => handleDelete(location?.pathname.split('/')[2] || '')}
              sx={{
                backgroundColor: zeplinColor.BasicBlack,
                color: zeplinColor.Neutral1,
                '& .MuiChip-deleteIcon': {
                  color: zeplinColor.Neutral1,
                  '&:hover': {
                    color: zeplinColor.Neutral4,
                  },
                },
                '&:hover': {
                  backgroundColor: zeplinColor.BasicBlack,
                },
              }}
            />
          ) : (
            <Box
              sx={{
                borderRadius: '28px',
                padding: '6px 12px',
                border: `1px solid ${zeplinColor.BasicBlack}`,
                display: 'flex',
                alignItems: 'center',
                gap: '4px',
                cursor: 'pointer',
              }}
              onClick={() => addTarget(data?.id)}
            >
              <img src={'/assets/add.svg'} width={'18px'} height={'18px'} alt='target account' />
              <Typography variant='responsiveButtonSmall'>Target Account</Typography>
            </Box>
          )}
          {/* <Chip
            icon={<img src={'/assets/add.svg'} width='18px' height='18px' />}
            label='Add List'
            onClick={(e: any) => {
              handleClick(e);
              setType('List');
            }}
            //   onDelete={handleDelete}
            sx={{
              backgroundColor: zeplinColor.Neutral1,
              color: zeplinColor.BasicBlack,
              border: `1px dashed ${zeplinColor.BasicBlack}`,
              strokeDasharray: [5, 50],
              position: 'relative',
            }}
          /> */}
        </Box>
      </Box>
      {/* <Box sx={{ display: 'flex', gap: '16px', alignItems: 'flex-start' }}>
        <Box sx={{ display: 'flex', gap: '8px', width: '58px', alignItems: 'center' }}>
          <img
            src={'/assets/zoominfo-tags.svg'}
            width={'20px'}
            height={'20px'}
            alt='zoominfo-lists'
          />
          <Typography variant='responsiveBody3' color={zeplinColor.Neutral8}>
            Tag
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
          {tagData?.map((val: any) => (
            <Chip
              icon={<img src={'/assets/zoominfo-check.svg'} width='18px' height='18px' />}
              label={val?.tag}
              // onClick={(e:any)=>{handleClick(e)}}
              onDelete={() => {
                deleteTag(val?.tag);
              }}
              sx={{
                backgroundColor: zeplinColor.BasicBlack,
                color: zeplinColor.Neutral1,
                '& .MuiChip-deleteIcon': {
                  color: zeplinColor.Neutral1,
                  '&:hover': {
                    color: zeplinColor.Neutral4,
                  },
                },
                '&:hover': {
                  backgroundColor: zeplinColor.BasicBlack,
                },
              }}
            />
          ))}
          <Chip
            icon={<img src={'/assets/add.svg'} width='18px' height='18px' />}
            label='Add Tag'
            onClick={(e: any) => {
              handleClick(e);
              setType('Tag');
            }}
            //   onDelete={handleDelete}
            sx={{
              backgroundColor: zeplinColor.Neutral1,
              color: zeplinColor.BasicBlack,
              border: `1px dashed ${zeplinColor.BasicBlack}`,
              strokeDasharray: [5, 50],
              position: 'relative',
            }}
          />
        </Box>
      </Box> */}
      <CustomPopOver
        setAnchorEl={setAnchorEl}
        anchorEl={anchorEl}
        id={id}
        sx={{
          borderRadius: '14px',
          boxShadow: 'rgba(0, 0, 0, 0.15)',
          marginTop: '8px',
          // marginRight: '2rem',
          // marginLeft: '-4rem',
        }}
      >
        <Box
          sx={{
            // height: { xs: '170px', xl: '202px' },
            // width: { xs: '300px', xl: '340px' },
            padding: { xs: '18px', xl: '24px' },
            display: 'flex',
            gap: { xs: '26px', xl: '32px' },
            flexDirection: 'column',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              width: '100%',
              alignItems: 'center',
            }}
          >
            <Typography variant='responsiveHeading3'>Add {type}</Typography>
            <img
              src={'/assets/close-icon.svg'}
              className={styles['icon-24']}
              alt='close'
              style={{ cursor: 'pointer' }}
              onClick={() => {
                setAnchorEl(null);
              }}
            />
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: '16px' }}>
            <CustomTextField
              style={{ width: '100%' }}
              onBlur={handleTagBlur}
              onChange={handleTagChange}
              name={`Enter ${type?.toLocaleLowerCase()} name`}
              text={tag}
              form={true}
              error={false}
              label={`Enter ${type?.toLocaleLowerCase()} name`}
              type='text'
              tabindex={1}
              // required
            />
            <Box
              sx={{
                padding: '18px 24px',
                borderRadius: '14px',
                backgroundColor: tag && !loading ? zeplinColor.Brand1 : zeplinColor.Neutral5,
              }}
              // onClick={addTag}
            >
              <Typography
                variant='responsiveButtonMedium'
                color={tag && !loading ? zeplinColor.Neutral1 : zeplinColor.Neutral8}
              >
                {loading ? 'Adding' : 'Add'}
              </Typography>
            </Box>
          </Box>
        </Box>
      </CustomPopOver>
      <CustomAlert
        open={alert ? true : false}
        handleClose={() => setAlert('')}
        message={
          <CustomAlertContain
            alertIcon={
              alert && !alert?.includes('successfully') ? (
                <img src='/assets/error.svg' width={24} height={24} />
              ) : (
                <img src='/assets/checkmark-green.png' width={24} height={24} />
              )
            }
            alert={alert}
          />
        }
        error={alert && !alert?.includes('successfully') ? true : false}
      />
    </Box>
  );
};

export default ListTagsCard;
